import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import {
  AccountResetPasswordRequestBody,
  AccountResetPasswordResponse,
} from "./types";

export class AccountResetPasswordAPI extends BaseAPI<
  AccountResetPasswordRequestBody,
  AccountResetPasswordResponse
> {
  protected route = ApiRoutes.account.reset_password;
  protected method = RequestMethod.POST;
}
